import { render } from "./CompanyReportTableWrapper.vue?vue&type=template&id=45ee8b69&scoped=true"
const script = {}

import "./CompanyReportTableWrapper.vue?vue&type=style&index=0&id=45ee8b69&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ee8b69"]])

export default __exports__